<template>
  <!-- :cpntAbaNewTab="() => { demEdiProDocVolumeAdicionar(false) }" -->
  <RF-Dialog :data-time="time"
  :cpntStatus='statusGeral'
  :cpntLargura='"600px"'

  :cpntAbaVet="valores"
  :cpntAbaValue="aba"
  :cpntAbaOnChange="demEdiProDocVolumeOnChangeAba"

  :cpntOnFecharDialog='demEdiProDocVolumeFechar'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Cadastro de volumes da NF-e
    </template>

    <template slot='conteudo' v-if="statusGeral === ''">
      <div class="dem-edi-pro-doc-volume">
        <div>
          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.especie.status'
            :cpntId='campos.especie.id'
            :cpntClassDivField='campos.especie.classDivField'
            :cpntNome='campos.especie.nome'
            :cpntValue='campos.especie.value'
            :cpntAutoComplete='campos.especie.autocomplete'
            :cpntMask='campos.especie.mask'
            :cpntOptionInicialNome='campos.especie.optionInicialNome'
            :cpntOptionInicialValue='campos.especie.optionInicialValue'
            :cpntDisabled='campos.especie.disabled'
            :cpntMostrar='campos.especie.mostrar'
            :cpntAutoFocus='campos.especie.autofocus'
            :cpntMensagem='campos.especie.mensagem'
            :cpntMensagemTipo='campos.especie.mensagemTipo'
            :cpntPlaceholder='campos.especie.placeholder'
            :cpntPosicionar='campos.especie.posicionar'
            :cpntOnChange='campos.especie.onChange'
            :cpntOnBlur='campos.especie.onBlur'
            ref='especie'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.marca.status'
            :cpntId='campos.marca.id'
            :cpntClassDivField='campos.marca.classDivField'
            :cpntNome='campos.marca.nome'
            :cpntValue='campos.marca.value'
            :cpntAutoComplete='campos.marca.autocomplete'
            :cpntMask='campos.marca.mask'
            :cpntOptionInicialNome='campos.marca.optionInicialNome'
            :cpntOptionInicialValue='campos.marca.optionInicialValue'
            :cpntDisabled='campos.marca.disabled'
            :cpntMostrar='campos.marca.mostrar'
            :cpntAutoFocus='campos.marca.autofocus'
            :cpntMensagem='campos.marca.mensagem'
            :cpntMensagemTipo='campos.marca.mensagemTipo'
            :cpntPlaceholder='campos.marca.placeholder'
            :cpntPosicionar='campos.marca.posicionar'
            :cpntOnChange='campos.marca.onChange'
            :cpntOnBlur='campos.marca.onBlur'
            ref='marca'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.quantidade.status'
            :cpntId='campos.quantidade.id'
            :cpntClassDivField='campos.quantidade.classDivField'
            :cpntNome='campos.quantidade.nome'
            :cpntValue='campos.quantidade.value'
            :cpntAutoComplete='campos.quantidade.autocomplete'
            :cpntMask='campos.quantidade.mask'
            :cpntOptionInicialNome='campos.quantidade.optionInicialNome'
            :cpntOptionInicialValue='campos.quantidade.optionInicialValue'
            :cpntDisabled='campos.quantidade.disabled'
            :cpntMostrar='campos.quantidade.mostrar'
            :cpntAutoFocus='campos.quantidade.autofocus'
            :cpntMensagem='campos.quantidade.mensagem'
            :cpntMensagemTipo='campos.quantidade.mensagemTipo'
            :cpntPlaceholder='campos.quantidade.placeholder'
            :cpntPosicionar='campos.quantidade.posicionar'
            :cpntOnChange='campos.quantidade.onChange'
            :cpntOnBlur='campos.quantidade.onBlur'
            ref='quantidade'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.numeracao.status'
            :cpntId='campos.numeracao.id'
            :cpntClassDivField='campos.numeracao.classDivField'
            :cpntNome='campos.numeracao.nome'
            :cpntValue='campos.numeracao.value'
            :cpntAutoComplete='campos.numeracao.autocomplete'
            :cpntMask='campos.numeracao.mask'
            :cpntOptionInicialNome='campos.numeracao.optionInicialNome'
            :cpntOptionInicialValue='campos.numeracao.optionInicialValue'
            :cpntDisabled='campos.numeracao.disabled'
            :cpntMostrar='campos.numeracao.mostrar'
            :cpntAutoFocus='campos.numeracao.autofocus'
            :cpntMensagem='campos.numeracao.mensagem'
            :cpntMensagemTipo='campos.numeracao.mensagemTipo'
            :cpntPlaceholder='campos.numeracao.placeholder'
            :cpntPosicionar='campos.numeracao.posicionar'
            :cpntOnChange='campos.numeracao.onChange'
            :cpntOnBlur='campos.numeracao.onBlur'
            ref='numeracao'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.peso_liquido.status'
            :cpntId='campos.peso_liquido.id'
            :cpntClassDivField='campos.peso_liquido.classDivField'
            :cpntNome='campos.peso_liquido.nome'
            :cpntValue='campos.peso_liquido.value'
            :cpntAutoComplete='campos.peso_liquido.autocomplete'
            :cpntMask='campos.peso_liquido.mask'
            :cpntOptionInicialNome='campos.peso_liquido.optionInicialNome'
            :cpntOptionInicialValue='campos.peso_liquido.optionInicialValue'
            :cpntDisabled='campos.peso_liquido.disabled'
            :cpntMostrar='campos.peso_liquido.mostrar'
            :cpntAutoFocus='campos.peso_liquido.autofocus'
            :cpntMensagem='campos.peso_liquido.mensagem'
            :cpntMensagemTipo='campos.peso_liquido.mensagemTipo'
            :cpntPlaceholder='campos.peso_liquido.placeholder'
            :cpntPosicionar='campos.peso_liquido.posicionar'
            :cpntOnChange='campos.peso_liquido.onChange'
            :cpntOnBlur='campos.peso_liquido.onBlur'
            ref='peso_liquido'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field"
            :cpntStatus='campos.peso_bruto.status'
            :cpntId='campos.peso_bruto.id'
            :cpntClassDivField='campos.peso_bruto.classDivField'
            :cpntNome='campos.peso_bruto.nome'
            :cpntValue='campos.peso_bruto.value'
            :cpntAutoComplete='campos.peso_bruto.autocomplete'
            :cpntMask='campos.peso_bruto.mask'
            :cpntOptionInicialNome='campos.peso_bruto.optionInicialNome'
            :cpntOptionInicialValue='campos.peso_bruto.optionInicialValue'
            :cpntDisabled='campos.peso_bruto.disabled'
            :cpntMostrar='campos.peso_bruto.mostrar'
            :cpntAutoFocus='campos.peso_bruto.autofocus'
            :cpntMensagem='campos.peso_bruto.mensagem'
            :cpntMensagemTipo='campos.peso_bruto.mensagemTipo'
            :cpntPlaceholder='campos.peso_bruto.placeholder'
            :cpntPosicionar='campos.peso_bruto.posicionar'
            :cpntOnChange='campos.peso_bruto.onChange'
            :cpntOnBlur='campos.peso_bruto.onBlur'
            ref='peso_bruto'
          ></App-Input>
        </div>

        <div>
          <RF-Button :data-time='time' class="app-cpnt-field"
          :cpntStatus='excluirBT.status' 
          :cpntId='excluirBT.id' 
          :cpntTipo='excluirBT.tipo' 
          :cpntIcone='excluirBT.icone' 
          :cpntTexto='excluirBT.texto' 
          :cpntClass='excluirBT.class'
          :cpntMostrar='excluirBT.mostrar'
          :cpntExplica='excluirBT.explica'
          :cpntTabIndex='excluirBT.tabIndex'
          @onClickButton='excluirBT.onClick'>
          </RF-Button>
        </div>
      </div>
    </template>

    <template slot='rodape-right' v-if="Object.keys(botoes).length >= 1">
      <div class="dem-edi-pro-doc-volume-rodape-right">
        <RF-Button v-for='(button, index) in botoes' :key="'bt--' + index"
          :data-time='time'

          :cpntStatus='button.status' 
          :cpntId='button.id' 
          :cpntTexto='button.texto' 
          :cpntClass='button.class'
          :cpntMostrar='button.mostrar'
          :cpntTabIndex='button.tabIndex'

          @onClickButton='button.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.dem-edi-pro-doc-volume {
padding: 23px 10px 15px 10px;
}
  .dem-edi-pro-doc-volume > div {
    width: 100%;
  }
  .dem-edi-pro-doc-volume > div:not(:first-child) {
    padding-top: 22px;
  }
  .dem-edi-pro-doc-volume > div:last-child {
    text-align: center;
  }
    .dem-edi-pro-doc-volume > div > div {
      display: inline-block;
      width: calc(50% - 5px);
    }
    .dem-edi-pro-doc-volume > div > div:first-child {
      margin-right: 5px;
    }
    .dem-edi-pro-doc-volume > div > div:last-child {
      margin-left: 5px;
    }

  .dem-edi-pro-doc-volume-rodape-right {
    float: right;
    margin: -4px;
    text-align: right;
  }
    .dem-edi-pro-doc-volume-rodape-right > button {
      margin: 4px;
    }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntDemandaId: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntVolumes: {
        required: true,
        type: Array
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        aba: '',
        valores: {},
        campos: {
          especie: {
            id: 'dem-edi-pro-doc-volume--especie',
            status: '',
            nome: 'Espécie',
            value: '',
            apiRec: 'p_doc_fre_vol_esp',
            apiEnv: 'p_doc_fre_vol_esp',
            onChange: this.demEdiProDocVolumeOnChange
          },
          marca: {
            id: 'dem-edi-pro-doc-volume--marca',
            status: '',
            nome: 'Marca',
            value: '',
            apiRec: 'p_doc_fre_vol_mar',
            apiEnv: 'p_doc_fre_vol_mar',
            onChange: this.demEdiProDocVolumeOnChange
          },
          quantidade: {
            id: 'dem-edi-pro-doc-volume--quantidade',
            status: '',
            nome: 'Quantidade',
            value: '',
            apiRec: 'p_doc_fre_vol_qtde',
            apiEnv: 'p_doc_fre_vol_qtde',
            onChange: this.demEdiProDocVolumeOnChange
          },
          numeracao: {
            id: 'dem-edi-pro-doc-volume--numeracao',
            status: '',
            nome: 'Numeração',
            value: '',
            apiRec: 'p_doc_fre_vol_num',
            apiEnv: 'p_doc_fre_vol_num',
            onChange: this.demEdiProDocVolumeOnChange
          },
          peso_liquido: {
            id: 'dem-edi-pro-doc-volume--peso_liquido',
            status: '',
            nome: 'Peso Líquido (Kg)',
            value: '',
            apiRec: 'p_doc_fre_vol_pl',
            apiEnv: 'p_doc_fre_vol_pl',
            mask: 'numero_decimal',
            onChange: this.demEdiProDocVolumeOnChange
          },
          peso_bruto: {
            id: 'dem-edi-pro-doc-volume--peso_bruto',
            status: '',
            nome: 'Peso Bruto (Kg)',
            value: '',
            apiRec: 'p_doc_fre_vol_pb',
            apiEnv: 'p_doc_fre_vol_pb',
            mask: 'numero_decimal',
            onChange: this.demEdiProDocVolumeOnChange
          }
        },
        botoes: {
          cancelar: {
            id: 'dem-edi-pro-doc-volume--cancelar',
            status: '',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            disabled: false,
            onClick: () => { this.demEdiProDocVolumeFechar(false) }
          },
          salvar: {
            id: 'dem-edi-pro-doc-volume--salvar',
            status: '',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            disabled: false,
            onClick: () => { this.demEdiProDocVolumeSalvarFormulario() }
          }
        },
        excluirBT: {
          id: 'dem-edi-pro-doc-volume--excluir',
          status: '',
          texto: 'Excluir este volume',
          class: [ 'btn', 'btn-danger', 'btn-sm' ],
          mostrar: true,
          disabled: false,
          onClick: () => { this.demEdiProDocVolumeExcluir(false) }
        }
      }
    },
    mounted: function () {
      this.demEdiProDocVolumeIniciar()
    },
    methods: {
      demEdiProDocVolumeIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiProDocVolumeSetarStatusGeral('carregando')

        // PEGA OS VALORES EXISTENTES
        var valores = JSON.parse(JSON.stringify(this.cpntVolumes))

        // SETA O VALOR INICIAL, SE NÃO TIVER NENHUM VALOR EXISTENTE
        if (valores.length === 0) {
          this.demEdiProDocVolumeAdicionar()
        } else {
          this.demEdiProDocVolumeMontarValores(valores)
        }

        // MANDA ABRIR NA PRIMEIRA ABA
        this.demEdiProDocVolumeOnChangeAba(Object.keys(this.valores)[0])

        // SETA O STATUS DA TELA
        this.demEdiProDocVolumeSetarStatusGeral('')
      },
      demEdiProDocVolumeMontarValores: function (valores) {
        // INICIA A VARIAVEL PARA RECEBER OS DADOS
        var vetor = {}

        // RODA O FOR CRIANDO AS CHAVES NECESSARIAS
        for (var indexV in valores) {
          // INICIA O NOME DA CHAVE DA ABA
          var chave = 'volume_' + indexV

          // SETA O VALOR NO VETOR
          vetor[chave] = Object.assign(valores[indexV], { chave: chave, nome: 'Volume ' + (Number(indexV) + 1) })
        }

        // SETA OS VALORES MONTADOS
        this.valores = vetor
      },
      demEdiProDocVolumeSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocVolumeFechar: function (atualizar = false) {
        // SETA OS VALORES
        var valor = []

        // VERIFICA SE FOI ADICIONADO OU EXCLUIDO ALGUM NOVO VOLUME
        if (atualizar === false && Object.values(JSON.parse(JSON.stringify(this.valores))).length !== this.cpntVolumes.length) {
          atualizar = true
        }

        // VERIFICA SE DEVE PEGAR OS VALORES
        if (atualizar === true) {
          valor = Object.values(JSON.parse(JSON.stringify(this.valores)))
        }

        // CHAMA A FUNÇÃO PARA FECHAR A TELA
        this.cpntFecharFormulario(atualizar, valor)
      },
      demEdiProDocVolumeOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // PEGA O NOME DA CHAVE QUE TEM QUE ATUALIZAR
        var chave = this.campos[indexF[1]].apiRec

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.valores[this.aba][chave] = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocVolumeOnChangeAba: function (aba) {
        // SETA A ABA SELECIONADA
        this.aba = aba

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA SETAR OS VALORES DA ABA
        this.demEdiProDocVolumeSetarValoresAba()
      },
      demEdiProDocVolumeSetarValoresAba: function () {
        // PEGA OS VALORES DA ABA SELECINADA
        var aba = JSON.parse(JSON.stringify(this.valores[this.aba]))

        // PREENCHE O VALORE EM TODOS OS CAMPOS
        for (var index in this.campos) {
          // PEGA O NOME DA CHAVE QUE DEVE PEGAR O VALOR
          var chave = this.campos[index].apiRec

          // SETA O VALOR RECEBIDO
          this.$set(this.campos[index], 'value', aba[chave])
  
          // LIMPA O CAMPO DE MENSAGEM DE ERRO
          this.$set(this.campos[index], 'mensagem', '')
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocVolumeAdicionar: function () {
        // INICIA O VETOR PARA RECEBER OS DADOS PARA NOVA ABA
        var vetor = {
          id: '',
          p_doc_fre_vol_esp: '',
          p_doc_fre_vol_mar: '',
          p_doc_fre_vol_num: '',
          p_doc_fre_vol_qtde: '',
          p_doc_fre_vol_pb: '',
          p_doc_fre_vol_pl: ''
        }

        // PEGA O NUMERO DA ULTIMA ABA EXISTENTE NO VETOR
        vetor.index = Number(Object.keys(this.valores).length) + 1

        // PEGA O NUMERO DA ULTIMA ABA EXISTENTE NO VETOR
        vetor.chave = 'volume_' + vetor.index

        // SETA O NOME DA ABA
        vetor.nome = 'Volume ' + vetor.index

        // SETA AS ABAS
        this.valores[vetor.chave] = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // FAZ A ALTERAÇÃO DE ABA
        setTimeout(() => { this.demEdiProDocVolumeOnChangeAba(vetor.chave) }, 100)
      },
      demEdiProDocVolumeExcluir: function (forcar = false) {
        if (forcar === true || [ '', null, undefined, 'venda' ].indexOf(this.cpntDemanda) !== -1 || [ '', null, undefined ].indexOf(this.valores[this.aba].id) !== -1) {
          // REMOVE O VOLUME SOLICTADO
          delete this.valores[this.aba]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // TRATA OS VALORES EXISTENTES
          if (Object.keys(this.valores).length >= 1) {
            // PEGA OS VALORES EXISTENTES
            var valores = JSON.parse(JSON.stringify(this.valores))

            // CHAMA FUNÇÃO PARA REORDENAR OS NOMES
            this.demEdiProDocVolumeMontarValores(Object.values(valores))

            // MANDA ABRIR A PRIMEIRA ABA ENCONTRADA
            this.demEdiProDocVolumeOnChangeAba(Object.keys(this.valores)[0])
          } else {
            this.demEdiProDocVolumeFechar(true)
          }
        } else {
          // INICIA O FORMULARIO QUE SERÁ ENVAIDO PARA API
          var formData = {}

          // SETA O ID QUE SERÁ REMOVIDO
          formData.id = this.valores[this.aba].id

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // INICIA A VARIAVEL DE ROTA
          var router = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/dem-df-volume'
              break

            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/dem-df-volume'
              break

            case 'compra':
              router = '/demanda/dem-compra/dem-df-volume'
              break
          }

          // FAZ A COMUNICAÇÃO COM A API


          this.$store.state.comunicaAPI(router, 'DELETE', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiProDocVolumeTratarValidacao(retorno.message, retorno.code)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // MANDA EXCLUIR A ABA
              this.demEdiProDocVolumeExcluir(true)
            }
          }, this.demEdiProDocVolumeSetarStatusGeral, this.demEdiProDocVolumeTratarValidacao)
        }
      },
      demEdiProDocVolumeSalvarFormulario: function () {
        if ([ '', null, undefined, 'venda' ].indexOf(this.cpntDemanda) !== -1) {
          this.demEdiProDocVolumeFechar(true)
        } else {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // INICIA OS FORMULARIOS QUE SERÁ ENVIADO
          var formDataPost = []
          var formDataPut = []

          // RODA O VETOR PROCURANDO OS VALORES QUE DEVE ATUALIZAR
          for (var index in this.valores) {
            // PEGA O VETOR DE DADOS
            var vetor = JSON.parse(JSON.stringify(this.valores[index]))

            // REMOVE AS CHAVES QUE NÃO SERÁ UTILIZADA
            delete vetor.chave
            delete vetor.index
            delete vetor.nome

            // VERIFICA SE DEVE INSERIR OU ATUALIZAR
            if (vetor.id === '') {
              // SETA OS DADOS DA DEMANDA
              vetor[chaveD] = this.cpntDemandaId

              // ADICIONA O FORMULARIO PARA SALVAR
              formDataPost.push(vetor)
            } else {
              // PEGA O VOLUME SOLICITADO
              var volume = this.cpntVolumes.filter(item => item.id === vetor.id)

              // PEGA O VALOR ENCONTRADO
              volume = volume.length === 1 ? volume[0] : {}

              // VERIFICA SE TEM ALGUMA DIFERENÇA NOS CAMPOS
              if ((volume.p_doc_fre_vol_esp !== vetor.p_doc_fre_vol_esp) || (volume.p_doc_fre_vol_mar !== vetor.p_doc_fre_vol_mar) || (volume.p_doc_fre_vol_num !== vetor.p_doc_fre_vol_num) || (volume.p_doc_fre_vol_pb !== vetor.p_doc_fre_vol_pb) || (volume.p_doc_fre_vol_pl !== vetor.p_doc_fre_vol_pl) || (volume.p_doc_fre_vol_qtde !== vetor.p_doc_fre_vol_qtde)) {
                formDataPut.push(vetor)
              }
            }
          }

          // CONVERTE OS FORMULARIOS EM LOT
          formDataPost = { lot: formDataPost }
          formDataPut = { lot: formDataPut }

          // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
          this.demEdiProDocVolumeSalvar(formDataPost, 'POST', (atualiza_post) => {
            this.demEdiProDocVolumeSalvar(formDataPut, 'PUT', (atualiza_put) => {
              // APRESENTA A MENSAGEM DE ATUALIZAÇÃO
              if (atualiza_post === true || atualiza_put === true) {
                this.$store.state.msgWarn('WEB [200]: Volume(s) atualizado(s) com sucesso.', 'success')
              }

              // MANDA FECHAR A TELA
              this.demEdiProDocVolumeFechar((atualiza_post === true || atualiza_put === true))
            })
          })
        }
      },
      demEdiProDocVolumeSalvar: function (formData, method, callback) {
        if (formData.lot.length >= 1) {
          // INICIA A VARIAVEL DE ROTA
          var router = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/dem-df-volume'
              break

            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/dem-df-volume'
              break

            case 'compra':
              router = '/demanda/dem-compra/dem-df-volume'
              break
          }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiProDocVolumeTratarValidacao(retorno.message, retorno.code)
            } else {
              callback(true)
            }
          }, this.demEdiProDocVolumeSetarStatusGeral, this.demEdiProDocVolumeTratarValidacao)
        } else {
          callback(false)
        }
      },
      demEdiProDocVolumeTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {          
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      }
    }
  }
</script>
